import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=a71d0b80&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
import style0 from "./Switch.vue?vue&type=style&index=0&id=a71d0b80&prod&lang=scss&scoped=true"
import style1 from "./Switch.vue?vue&type=style&index=1&id=a71d0b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71d0b80",
  null
  
)

export default component.exports